import { PresentationRole } from "@/apis/preview/v2/types";
import { GetCellOfRoleResponse } from "@/apis/workbook/types";
import useRoleOfCell from "@/hooks/queries/use-role-of-cell";
import { useWorkbookId } from "@/hooks/use-workbook";
import { CellType, useMappingStore } from "@/stores/mapping";
import { Skeleton } from "@/styles/ui/skeleton";
import { useTableId } from "../hooks";
import { StandardChip, ExtendedChip } from "@/components/common/standard-chip";
import { ConnectorIcon } from "@/components/icons/connector-icon";
import { cn } from "@/lib/utils";
import { useCategory } from "@/hooks/use-category";

const MappingTitlePl = ({
  preRole,
  isRoleLoading,
}: {
  preRole?: PresentationRole;
  isRoleLoading: boolean;
}) => {
  const setViewState = useMappingStore((state) => state.viewState.set);

  return (
    <button
      className="flex items-center gap-2 self-stretch"
      onClick={() => {
        setViewState("ROLE_SELECTION");
      }}
    >
      {preRole?.isExtended ? <ExtendedChip /> : <StandardChip />}
      <span className="text-primary body-2-normal-medium">
        {isRoleLoading ? (
          <Skeleton className="h-[24px] w-[100px] rounded-xl bg-neutral-100" />
        ) : preRole ? (
          preRole.label
        ) : (
          "헤더"
        )}
      </span>
    </button>
  );
};

const MappingTitleDl = ({
  role,
  isRoleLoading,
}: {
  role?: GetCellOfRoleResponse;
  isRoleLoading: boolean;
}) => {
  return (
    <div className="flex pl-[30px] items-center gap-2 self-stretch">
      {role?.defRole.label ? (
        <>
          {role?.defRole.isExtended ? <ExtendedChip /> : <StandardChip />}
          <span className="text-[#0A0A0A] body-2-normal-medium">
            {role?.defRole.label}
          </span>
        </>
      ) : isRoleLoading ? (
        <Skeleton className="h-[19px] w-[100px] rounded-xl bg-neutral-100" />
      ) : (
        <span className="text-[#0A0A0A] body-2-normal-medium">
          태깅할 수 없는 셀입니다.
        </span>
      )}
    </div>
  );
};

export const MappingTitleSection = () => {
  const selectedFact = useMappingStore((state) => state.fact.selected);

  const { data: workbookId } = useWorkbookId();
  const {
    data: { tableId: tableId },
  } = useTableId();

  const { data: role, isLoading: isRoleLoading } = useRoleOfCell({
    workbookId: workbookId,
    tableId: tableId,
    cellAddress: selectedFact?.address,
    enabled:
      selectedFact?.cellType &&
      [CellType.SUM, CellType.DATA].includes(selectedFact?.cellType),
  });
  const { category } = useCategory();

  return (
    <div className="flex flex-col w-full border-b-[1px] p-5 justify-center items-start gap-3 self-stretch">
      <div className="relative flex flex-col items-start gap-2 self-stretch">
        {/* 프레젠테이션 링크 Tab */}
        <MappingTitlePl preRole={category?.preRole} isRoleLoading={!category} />
        {/* 데피니션 링크 Tab */}
        {(role?.defRole.label || isRoleLoading) && (
          <>
            <MappingTitleDl role={role} isRoleLoading={isRoleLoading} />
            <ConnectorIcon
              className={cn(
                "absolute left-[14px] bottom-[11px]",
                role?.defRole.isExtended
                  ? "stroke-purple-100"
                  : "stroke-slate-200",
              )}
            />
          </>
        )}
      </div>
    </div>
  );
};
